export default {
    services: '1 услуга | {n} услуг',
    reservations: '1 бронирование | {n} бронирований',
    offer_company: 'Услуги компании',
    offer_user: 'Пользовательские услуги',
    no_slots_in_past: 'Нет бронирований на выбранную дату',
    filter: 'Фильтр',
    error_slot_within_two_hours: 'Слоты в следующие два часа не могут быть изменены',
    status_successfully_changed: 'Статус бронирования успешно изменен',
    unavailable_slot: 'Слот недоступен',
    shorten_reservation: 'Сокращенное бронирование',
    go_to_next_month: 'В следующем месяце',
}
